import type { ReadContractorVisit } from "@/types/contractorVisit";

type Visibility = Pick<
  ReadContractorVisit,
  | "planned_duration_visible"
  | "can_view_planned_duration"
  | "planned_duration_visibility_valid_until"
>;

// The legacy project flag retains its meaning for actual-duration rendering.
// Missing new fields retain compatibility with older API responses.
export const isPlannedDurationVisible = (
  visit: Visibility,
  now = Date.now(),
) => {
  if (
    !visit.planned_duration_visible ||
    visit.can_view_planned_duration === false
  )
    return false;
  if (!visit.planned_duration_visibility_valid_until) return true;
  return now < Date.parse(visit.planned_duration_visibility_valid_until);
};
